var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"items":_vm.breadcrumbs}}),_c('heading',{attrs:{"helpInfo":_vm.sidebarCard}},[_vm._v(" "+_vm._s(_vm.folderName || _vm.$t("sidebar.inspections"))+" ")]),_c('inspectionTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }